import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';

export const StyledButton = styled(LoadingButton)`
  display: flex;
  align-items: center;
  padding: 0 24px;
  height: 48px;
  background: ${(props) => (props.disabled ? '#2ADDBA !important' : '#2ADDBA')};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  font-size: 16px;
  font-weight: 600;
  font-family: 'General Sans';
  color: white;
  text-transform: none;
  border-radius: 0;
  transition: background 350ms;

  &:hover {
    background: #2dc2b3;
  }
`;
